import React, {useEffect, useState} from "react";
import {Button, Col, Icon, Modal, notification, Row, Table, Upload} from "antd";
import Spinner from "../../spinner";
import {consignorService, systemService, userServices} from "../../../services";
import InputField from "../../input-field";
import SelectField from "../../select-field";
import {approveOrderService} from "../../../services/approve-order.service";
import FieldBlock from "../../field-block";
import DividerBlock from "../../divider-block";
import {formHelper} from "../../../helpers";
import {fileHelper, mimeTypes} from "../../../helpers/file.helper";
import {CONSIGNOR_DIRECTOR_PERMISSION} from "../../../helpers/user_permission.helper";
import i18n from "i18next";

export default function ModalApproveLegalEntityByLogist({isShow, setIsShow, orderInfo, setNeedUpdate, setStopListUpdate, typeName}) {
    const [loading, setLoading] = useState(true);

    const user = userServices.getUser();

    const [companyTypesList, setCompanyTypesList] = useState([]);
    const [companyType, setCompanyType] = useState(null);
    const [comment, setComment] = useState(null);
    const [companyTypeError, setCompanyTypeError] = useState(false);
    const [addDocs, setAddDocs] = useState([]);
    const [customAddDocs, setCustomAddDocs] = useState([]);

    const [fieldsErrors, setFieldsErrors] = useState([]);
    const getFieldErrors = (fieldName) => {
        return typeof fieldsErrors[fieldName] !== "undefined"
            ? fieldsErrors[fieldName].reduce((fieldErrors, error) => {
                return fieldErrors + "; " + error;
            })
            : null;
    };

    useEffect(() => {
        if (isShow && orderInfo) {
            systemService.getCompanyTypesList(orderInfo.orderType)
                .then(res => {
                    setCompanyTypesList(res);
                    setLoading(false);
                });
        }
    }, [isShow]);

    useEffect(() => {
        if (isShow && orderInfo.approveType) {
            approveOrderService.getAddParamsOnApproveLegalEntity(orderInfo.orderId, orderInfo.approveType)
                .then(res => {
                    let docs = [];
                    for (const [key, value] of Object.entries(res.params)) {
                        if (value.type === "doc") {
                            if (value.value) {
                                const contentType = fileHelper.getMimeTypeByExtension(value.extension);
                                const thumbURL = contentType === mimeTypes.pdf ? 'https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg' : null;
                                value.value = formHelper.createFile(value.value, contentType, value.name, value.alias, thumbURL, value.extension);
                            }
                            docs.push(value);
                        }
                    }
                    setAddDocs(docs);

                    let customDocs = [];
                    for (const [key, value] of Object.entries(res.customPrams)) {
                        const contentType = fileHelper.getMimeTypeByExtension(value.extension);
                        const thumbURL = contentType === mimeTypes.pdf ? 'https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg' : null;
                        customDocs.push(
                            formHelper.createFile(value.value, contentType, value.name, value.alias, thumbURL)
                        );
                    }
                    setCustomAddDocs(customDocs);
                })
                .catch(err => {
                    notification.error({
                        message: i18n.t('components.notification.titles.getAddParamsOnApproveLegalEntity'),
                        description: err,
                    });
                });
        }
    }, [isShow, orderInfo]);

    const handleAgreeOrder = () => {
        if (orderInfo && orderInfo.approveType === 'support_type' && !companyType) {
            setCompanyTypeError(true);
            notification.error({
                message: i18n.t('modals.modalApproveLegalEntityByLogist.type.title'),
                description: i18n.t('modals.modalApproveLegalEntityByLogist.type.required')
            });
            setLoading(false);
            return;
        }

        setCompanyTypeError(false);

        const proceedAgreeOrder = () => {
            setLoading(true);
            switch (orderInfo.orderType) {
                case "default":
                    consignorService
                        .approveOrder(orderInfo.orderId, orderInfo.approveType, addDocs, customAddDocs, companyType, comment)
                        .then((response) => {
                            if (response.code === 200) {
                                notification.success({
                                        message: i18n.t('components.notification.titles.approveOrder'),
                                        description: response.message
                                });
                                setStopListUpdate(false);
                                setNeedUpdate(true);
                                setIsShow(false);
                            } else {
                                setFieldsErrors(response.errors);
                                notification.error({
                                    message: i18n.t('components.notification.titles.approveOrder'),
                                    description: response.message
                                });
                            }
                        })
                        .catch(err => {
                            notification.error({
                                message: i18n.t('components.notification.titles.approveOrder'),
                                description: err
                            });
                        })
                        .finally(() => {
                            setLoading(false);
                        });
                    break;
                case "become_carrier":
                    consignorService
                        .approveOrderBecomeCarrier(orderInfo.orderId, companyType)
                        .then((response) => {
                            if (response.code === 200) {
                                notification.success({
                                    message: i18n.t('components.notification.titles.approveOrder'),
                                    description: response.message
                                });
                                setStopListUpdate(false);
                            } else {
                                notification.error({
                                    message: i18n.t('components.notification.titles.approveOrder'),
                                    description: response.message
                                });
                            }
                            setIsShow(false);
                            setLoading(false);
                        })
                        .catch(err => {
                            notification.error({
                                message: i18n.t('components.notification.titles.approveOrder'),
                                description: err
                            });

                            setLoading(false);
                        });
                    break;
            }
        };

        if (orderInfo && orderInfo.approveType === 'support_type' && Number(companyType) === 4 ) {
            Modal.confirm({
                title: `Настоящий тип компании: ${typeName}`,
                width: 720,
                centered: true,
                content: (
                    <div style={{fontSize: '14px', lineHeight: 1.5}}>
                        <div style={{fontWeight: 700, color: '#d46b08', marginBottom: '8px'}}>
                            Внимание!
                        </div>
                        <div style={{marginBottom: '10px'}}>
                            После изменения типа на <b>грузовладельца</b>, обратная замена будет невозможна.
                        </div>
                        <div style={{fontWeight: 600}}>
                            Вы действительно хотите изменить тип компании на грузовладельца?
                        </div>
                    </div>
                ),
                okText: 'Да',
                cancelText: 'Нет',
                onOk: () => proceedAgreeOrder(),
            });
            return;
        }

        proceedAgreeOrder();
    };

    const submitBtnStyle = {
        width: "200px",
        height: "43px",
        background: "#1CAA53",
        position: "static",
        borderRadius: "10px",
        color: "white",
        borderColor: "transparent",
    };

    const getUploaderClass = (index) => {
        return {
            multiple: false,
            showUploadList: true,
            onRemove: () => {
                let docs = addDocs;
                docs[index].value = null;

                setAddDocs([...docs]);
            },
            beforeUpload: (file) => {
                let docs = addDocs;
                docs[index].value = file;
                setAddDocs([...docs]);
                return false;
            },
            fileList: addDocs[index].value ? [addDocs[index].value] : null,
            listType: 'picture',
        };
    };

    const renderAddParamsForm = () => {
        if (!addDocs || addDocs.length === 0) {
            return null;
        }

        let docsFields = addDocs.map((file, index) => {
            return <Col lg={12} md={24} sm={24} xs={24} style={{margin:'0 0 15px 0'}}>
                <FieldBlock name={file.name} getErrors={getFieldErrors}>
                    <Upload
                        className="single-btn-upload"
                        name={file.name}
                        {...getUploaderClass(index)}
                    >
                        <Button htmlType="button">
                            <Icon type="upload" className="single-btn-upload__icon"/> {file.alias}
                        </Button>
                    </Upload>
                </FieldBlock>
            </Col>
        });

        return (
            <Row gutter={[16, 24]}>
                {docsFields}
            </Row>
        );
    };
    // Проверяем, нужно ли отключить кнопку
    const isSubmitDisabled = () => {
        return orderInfo && orderInfo.approveType === 'support_type' && !companyType;
        
    };
    return (
        <Modal
            //title={i18n.t('modals.modalApproveLegalEntityByLogist.title')}
            title={
                <div>
                    <div>{i18n.t('modals.modalApproveLegalEntityByLogist.title')}</div>
                    <div style={{ fontSize: 12, fontWeight: 'normal', color: '#666', marginTop: 4 }}>
                        Тип компании: {typeName}
                    </div>
                </div>
            }
            cancelText={i18n.t('main.buttons.close')}
            className="modal-window"
            align={null}
            visible={isShow}
            onCancel={() => {
                setIsShow(false);
            }}
            footer={
                <Button
                    htmlType="submit"
                    key="submit"
                    style={submitBtnStyle}
                    onClick={() => handleAgreeOrder()}
                    type="primary"
                    className="button-footer-create"
                    disabled={isSubmitDisabled()} // Кнопка отключена если не выбран тип
                >
                    {i18n.t('main.buttons.approve2')}
                </Button>
            }
        >
            <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
                {orderInfo && orderInfo.approveType === 'support_type' && <>
                <Row>
                    <Col lg={8} sm={24}>
                        <div style={{ position: 'relative' }}>
                            <SelectField
                                title={
                                    <span>
                        {i18n.t('modals.modalApproveLegalEntityByLogist.type.title')}
                                        <span style={{ color: '#ff4d4f', marginLeft: '4px' }}>*</span>
                    </span>
                                }
                                name="type"
                                selectedValue={companyType}
                                values={companyTypesList}
                                onChange={(value) => {
                                    setCompanyType(value);
                                    setCompanyTypeError(false); // Сбрасываем ошибку при выборе
                                }}
                                getErrors={getFieldErrors}
                                placeholder={i18n.t('modals.modalApproveLegalEntityByLogist.type.placeholder')}
                                notFoundText={null}
                                showArrow={true}
                                style={{width: "100%"}}
                                className={!companyType ? 'required-field-error' : ''}
                            />
                        </div>
                    </Col>
                </Row>
                { user.isAccessTo(CONSIGNOR_DIRECTOR_PERMISSION) &&
                <Row>
                    <Col lg={24} sm={24}>
                        <InputField
                            name="comment" label={i18n.t('modals.modalApproveLegalEntityByLogist.comment.label')}
                            value={comment} setValue={setComment}
                            getFieldErrors={getFieldErrors}
                        />
                    </Col>
                </Row>
                }
                </>
                }
                {orderInfo && orderInfo.approveComment && orderInfo.approveComment.length > 0 &&
                <Row>
                    <Col lg={24} sm={24}>
                        <DividerBlock label={i18n.t('modals.modalApproveLegalEntityByLogist.divider.approveComment')} />
                        <p>{orderInfo.approveComment}</p>
                    </Col>
                </Row>
                }
                <DividerBlock label={i18n.t('modals.modalApproveLegalEntityByLogist.divider.customDocs')} />
                {renderAddParamsForm()}
                <Row gutter={[16, 24]}>
                    <Col lg={12} md={24} sm={24} xs={24} style={{margin:'0 0 15px 0'}}>
                        <FieldBlock name="customDocs" getErrors={getFieldErrors}>
                            <Upload
                                className="single-btn-upload"
                                name="customDocs"
                                multiple={true}
                                showUploadList={true}
                                onRemove={(file) => {
                                    customAddDocs.forEach((stepFile, index) => {
                                        if (stepFile.uid === file.uid) {
                                            customAddDocs.splice(index, 1);
                                        }
                                        setCustomAddDocs([...customAddDocs]);
                                    });
                                }}
                                beforeUpload={(file) => {
                                        let docs = customAddDocs;
                                        docs.push(file);
                                        setCustomAddDocs([...docs]);
                                        return false;
                                    }
                                }
                                fileList={customAddDocs}
                                listType={'picture'}
                            >
                                <Button htmlType="button">
                                    <Icon type="upload" className="single-btn-upload__icon"/> {i18n.t('modals.modalApproveLegalEntityByLogist.customDocs')}
                                </Button>
                            </Upload>
                        </FieldBlock>
                    </Col>
                </Row>
            </Spinner>
        </Modal>
    );
}
